// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-coins2:before {
  content: "\\e800";
} /* '' */
.icon-swap:before {
  content: "\\e801";
} /* '' */
.icon-users:before {
  content: "\\e802";
} /* '' */
.icon-arrow_over:before {
  content: "\\e803";
} /* '' */
.icon-locked:before {
  content: "\\e804";
} /* '' */
.icon-smallest_first:before {
  content: "\\e805";
} /* '' */
.icon-flame:before {
  content: "\\e806";
} /* '' */
.icon-bookmark:before {
  content: "\\e807";
} /* '' */
.icon-close_md:before {
  content: "\\e808";
} /* '' */
.icon-dice:before {
  content: "\\e809";
} /* '' */
.icon-error:before {
  content: "\\e80a";
} /* '' */
.icon-blackjack:before {
  content: "\\e80b";
} /* '' */
.icon-globe:before {
  content: "\\e80c";
} /* '' */
.icon-calendar:before {
  content: "\\e80d";
} /* '' */
.icon-discord:before {
  content: "\\e80e";
} /* '' */
.icon-filter:before {
  content: "\\e80f";
} /* '' */
.icon-twitter:before {
  content: "\\e810";
} /* '' */
.icon-list_layout:before {
  content: "\\e811";
} /* '' */
.icon-volume_max:before {
  content: "\\e812";
} /* '' */
.icon-remove:before {
  content: "\\e813";
} /* '' */
.icon-linkedin:before {
  content: "\\e814";
} /* '' */
.icon-share:before {
  content: "\\e815";
} /* '' */
.icon-close_lg:before {
  content: "\\e816";
} /* '' */
.icon-crash:before {
  content: "\\e817";
} /* '' */
.icon-gift:before {
  content: "\\e818";
} /* '' */
.icon-clock:before {
  content: "\\e819";
} /* '' */
.icon-reddit:before {
  content: "\\e81a";
} /* '' */
.icon-hamburger_sm:before {
  content: "\\e81b";
} /* '' */
.icon-youtube:before {
  content: "\\e81c";
} /* '' */
.icon-twitch:before {
  content: "\\e81d";
} /* '' */
.icon-google:before {
  content: "\\e81e";
} /* '' */
.icon-send:before {
  content: "\\e81f";
} /* '' */
.icon-jackpot:before {
  content: "\\e820";
} /* '' */
.icon-unlocked:before {
  content: "\\e821";
} /* '' */
.icon-chat:before {
  content: "\\e822";
} /* '' */
.icon-arrow_down:before {
  content: "\\e823";
} /* '' */
.icon-play:before {
  content: "\\e824";
} /* '' */
.icon-limbo:before {
  content: "\\e825";
} /* '' */
.icon-hide:before {
  content: "\\e826";
} /* '' */
.icon-linked_in:before {
  content: "\\e827";
} /* '' */
.icon-coins:before {
  content: "\\e828";
} /* '' */
.icon-copy:before {
  content: "\\e829";
} /* '' */
.icon-gitbook:before {
  content: "\\e82a";
} /* '' */
.icon-add:before {
  content: "\\e82b";
} /* '' */
.icon-check:before {
  content: "\\e82c";
} /* '' */
.icon-arrow_under:before {
  content: "\\e82d";
} /* '' */
.icon-cointoss:before {
  content: "\\e82e";
} /* '' */
.icon-correct:before {
  content: "\\e82f";
} /* '' */
.icon-document:before {
  content: "\\e830";
} /* '' */
.icon-transactions:before {
  content: "\\e831";
} /* '' */
.icon-telegram:before {
  content: "\\e832";
} /* '' */
.icon-arrow_right:before {
  content: "\\e833";
} /* '' */
.icon-randomness:before {
  content: "\\e834";
} /* '' */
.icon-bell:before {
  content: "\\e835";
} /* '' */
.icon-wallet:before {
  content: "\\e836";
} /* '' */
.icon-arrow_up:before {
  content: "\\e837";
} /* '' */
.icon-layers:before {
  content: "\\e838";
} /* '' */
.icon-volume_off:before {
  content: "\\e839";
} /* '' */
.icon-external_link:before {
  content: "\\e83a";
} /* '' */
.icon-filter_sliders:before {
  content: "\\e83b";
} /* '' */
.icon-expand:before {
  content: "\\e83c";
} /* '' */
.icon-mines:before {
  content: "\\e83d";
} /* '' */
.icon-download:before {
  content: "\\e83e";
} /* '' */
.icon-shield:before {
  content: "\\e83f";
} /* '' */
.icon-roulette:before {
  content: "\\e840";
} /* '' */
.icon-close_sm:before {
  content: "\\e841";
} /* '' */
.icon-settings:before {
  content: "\\e842";
} /* '' */
.icon-grid_layout:before {
  content: "\\e843";
} /* '' */
.icon-link:before {
  content: "\\e844";
} /* '' */
.icon-arrow_left:before {
  content: "\\e845";
} /* '' */
.icon-keno:before {
  content: "\\e846";
} /* '' */
.icon-log_out2:before {
  content: "\\e847";
} /* '' */
.icon-wheel:before {
  content: "\\e848";
} /* '' */
.icon-baccarat:before {
  content: "\\e849";
} /* '' */
.icon-biggest_first:before {
  content: "\\e84a";
} /* '' */
.icon-show:before {
  content: "\\e84b";
} /* '' */
.icon-leadrboard:before {
  content: "\\e84c";
} /* '' */
.icon-credit_card:before {
  content: "\\e84d";
} /* '' */
.icon-shrink:before {
  content: "\\e84e";
} /* '' */
.icon-log_out:before {
  content: "\\e84f";
} /* '' */
.icon-hamburger_lg:before {
  content: "\\e850";
} /* '' */
.icon-favourite:before {
  content: "\\e851";
} /* '' */
.icon-music:before {
  content: "\\e852";
} /* '' */
.icon-alert:before {
  content: "\\e853";
} /* '' */
.icon-home:before {
  content: "\\e854";
} /* '' */
.icon-plinko:before {
  content: "\\e855";
} /* '' */
.icon-slots:before {
  content: "\\e856";
} /* '' */
.icon-user:before {
  content: "\\e857";
} /* '' */
.icon-platform:before {
  content: "\\e858";
} /* '' */
.icon-information:before {
  content: "\\e859";
} /* '' */
.icon-dots:before {
  content: "\\e85a";
} /* '' */
.icon-search:before {
  content: "\\e85b";
} /* '' */
.icon-medium:before {
  content: "\\e85c";
} /* '' */
`, "",{"version":3,"sources":["webpack://./src/components/common/iconFont/zb-icons-codes.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ;AACV;EACE,gBAAgB;AAClB,EAAE,QAAQ","sourcesContent":[".icon-coins2:before {\n  content: \"\\e800\";\n} /* '' */\n.icon-swap:before {\n  content: \"\\e801\";\n} /* '' */\n.icon-users:before {\n  content: \"\\e802\";\n} /* '' */\n.icon-arrow_over:before {\n  content: \"\\e803\";\n} /* '' */\n.icon-locked:before {\n  content: \"\\e804\";\n} /* '' */\n.icon-smallest_first:before {\n  content: \"\\e805\";\n} /* '' */\n.icon-flame:before {\n  content: \"\\e806\";\n} /* '' */\n.icon-bookmark:before {\n  content: \"\\e807\";\n} /* '' */\n.icon-close_md:before {\n  content: \"\\e808\";\n} /* '' */\n.icon-dice:before {\n  content: \"\\e809\";\n} /* '' */\n.icon-error:before {\n  content: \"\\e80a\";\n} /* '' */\n.icon-blackjack:before {\n  content: \"\\e80b\";\n} /* '' */\n.icon-globe:before {\n  content: \"\\e80c\";\n} /* '' */\n.icon-calendar:before {\n  content: \"\\e80d\";\n} /* '' */\n.icon-discord:before {\n  content: \"\\e80e\";\n} /* '' */\n.icon-filter:before {\n  content: \"\\e80f\";\n} /* '' */\n.icon-twitter:before {\n  content: \"\\e810\";\n} /* '' */\n.icon-list_layout:before {\n  content: \"\\e811\";\n} /* '' */\n.icon-volume_max:before {\n  content: \"\\e812\";\n} /* '' */\n.icon-remove:before {\n  content: \"\\e813\";\n} /* '' */\n.icon-linkedin:before {\n  content: \"\\e814\";\n} /* '' */\n.icon-share:before {\n  content: \"\\e815\";\n} /* '' */\n.icon-close_lg:before {\n  content: \"\\e816\";\n} /* '' */\n.icon-crash:before {\n  content: \"\\e817\";\n} /* '' */\n.icon-gift:before {\n  content: \"\\e818\";\n} /* '' */\n.icon-clock:before {\n  content: \"\\e819\";\n} /* '' */\n.icon-reddit:before {\n  content: \"\\e81a\";\n} /* '' */\n.icon-hamburger_sm:before {\n  content: \"\\e81b\";\n} /* '' */\n.icon-youtube:before {\n  content: \"\\e81c\";\n} /* '' */\n.icon-twitch:before {\n  content: \"\\e81d\";\n} /* '' */\n.icon-google:before {\n  content: \"\\e81e\";\n} /* '' */\n.icon-send:before {\n  content: \"\\e81f\";\n} /* '' */\n.icon-jackpot:before {\n  content: \"\\e820\";\n} /* '' */\n.icon-unlocked:before {\n  content: \"\\e821\";\n} /* '' */\n.icon-chat:before {\n  content: \"\\e822\";\n} /* '' */\n.icon-arrow_down:before {\n  content: \"\\e823\";\n} /* '' */\n.icon-play:before {\n  content: \"\\e824\";\n} /* '' */\n.icon-limbo:before {\n  content: \"\\e825\";\n} /* '' */\n.icon-hide:before {\n  content: \"\\e826\";\n} /* '' */\n.icon-linked_in:before {\n  content: \"\\e827\";\n} /* '' */\n.icon-coins:before {\n  content: \"\\e828\";\n} /* '' */\n.icon-copy:before {\n  content: \"\\e829\";\n} /* '' */\n.icon-gitbook:before {\n  content: \"\\e82a\";\n} /* '' */\n.icon-add:before {\n  content: \"\\e82b\";\n} /* '' */\n.icon-check:before {\n  content: \"\\e82c\";\n} /* '' */\n.icon-arrow_under:before {\n  content: \"\\e82d\";\n} /* '' */\n.icon-cointoss:before {\n  content: \"\\e82e\";\n} /* '' */\n.icon-correct:before {\n  content: \"\\e82f\";\n} /* '' */\n.icon-document:before {\n  content: \"\\e830\";\n} /* '' */\n.icon-transactions:before {\n  content: \"\\e831\";\n} /* '' */\n.icon-telegram:before {\n  content: \"\\e832\";\n} /* '' */\n.icon-arrow_right:before {\n  content: \"\\e833\";\n} /* '' */\n.icon-randomness:before {\n  content: \"\\e834\";\n} /* '' */\n.icon-bell:before {\n  content: \"\\e835\";\n} /* '' */\n.icon-wallet:before {\n  content: \"\\e836\";\n} /* '' */\n.icon-arrow_up:before {\n  content: \"\\e837\";\n} /* '' */\n.icon-layers:before {\n  content: \"\\e838\";\n} /* '' */\n.icon-volume_off:before {\n  content: \"\\e839\";\n} /* '' */\n.icon-external_link:before {\n  content: \"\\e83a\";\n} /* '' */\n.icon-filter_sliders:before {\n  content: \"\\e83b\";\n} /* '' */\n.icon-expand:before {\n  content: \"\\e83c\";\n} /* '' */\n.icon-mines:before {\n  content: \"\\e83d\";\n} /* '' */\n.icon-download:before {\n  content: \"\\e83e\";\n} /* '' */\n.icon-shield:before {\n  content: \"\\e83f\";\n} /* '' */\n.icon-roulette:before {\n  content: \"\\e840\";\n} /* '' */\n.icon-close_sm:before {\n  content: \"\\e841\";\n} /* '' */\n.icon-settings:before {\n  content: \"\\e842\";\n} /* '' */\n.icon-grid_layout:before {\n  content: \"\\e843\";\n} /* '' */\n.icon-link:before {\n  content: \"\\e844\";\n} /* '' */\n.icon-arrow_left:before {\n  content: \"\\e845\";\n} /* '' */\n.icon-keno:before {\n  content: \"\\e846\";\n} /* '' */\n.icon-log_out2:before {\n  content: \"\\e847\";\n} /* '' */\n.icon-wheel:before {\n  content: \"\\e848\";\n} /* '' */\n.icon-baccarat:before {\n  content: \"\\e849\";\n} /* '' */\n.icon-biggest_first:before {\n  content: \"\\e84a\";\n} /* '' */\n.icon-show:before {\n  content: \"\\e84b\";\n} /* '' */\n.icon-leadrboard:before {\n  content: \"\\e84c\";\n} /* '' */\n.icon-credit_card:before {\n  content: \"\\e84d\";\n} /* '' */\n.icon-shrink:before {\n  content: \"\\e84e\";\n} /* '' */\n.icon-log_out:before {\n  content: \"\\e84f\";\n} /* '' */\n.icon-hamburger_lg:before {\n  content: \"\\e850\";\n} /* '' */\n.icon-favourite:before {\n  content: \"\\e851\";\n} /* '' */\n.icon-music:before {\n  content: \"\\e852\";\n} /* '' */\n.icon-alert:before {\n  content: \"\\e853\";\n} /* '' */\n.icon-home:before {\n  content: \"\\e854\";\n} /* '' */\n.icon-plinko:before {\n  content: \"\\e855\";\n} /* '' */\n.icon-slots:before {\n  content: \"\\e856\";\n} /* '' */\n.icon-user:before {\n  content: \"\\e857\";\n} /* '' */\n.icon-platform:before {\n  content: \"\\e858\";\n} /* '' */\n.icon-information:before {\n  content: \"\\e859\";\n} /* '' */\n.icon-dots:before {\n  content: \"\\e85a\";\n} /* '' */\n.icon-search:before {\n  content: \"\\e85b\";\n} /* '' */\n.icon-medium:before {\n  content: \"\\e85c\";\n} /* '' */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
